import React from 'react'
import isEmpty from 'lodash/fp/isEmpty'
import { Box } from 'reflexbox'
import CardChore from 'components/ui/CardChore'

const KidChores = ({ chores, updateChore }) => (
  <>
    <h2 className="text-gray-300 font-light text-2xl mb-2">Chores</h2>
    {isEmpty(chores) ? (
      <div className="text-center w-full h-64 px-6 py-4 rounded-lg bg-white shadow-md">
        <div className="text-4xl font-bold mt-6 mb-4">
          <span role="img" aria-label="party popper">
            🎉
          </span>{' '}
          Yay!
        </div>
        <h3 className="text-2xl font-light text-gray-700">You're all done for today.</h3>
      </div>
    ) : (
      chores.map((chore, index) => (
        <Box mb={3} width={1} key={index}>
          <CardChore chore={chore} callback={updateChore} />
        </Box>
      ))
    )}
  </>
)

export default KidChores
